'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface FormData {
  companyName: string;
  contactPerson: string;
  email: string;
  phone: string;
  businessType: string;
  businessDesc: string;
  products: string[];
}

const productOptions = [
  '廚房用品 Kitchen Products',
  '收納整理用品 Storage & Organization',
  '清潔用品 Cleaning Products',
  '家居裝飾小物 Home Décor',
  '浴室及個人護理用品 Bathroom & Personal Care',
  '季節性及功能性產品 Seasonal & Functional',
];

export default function RegisterPage() {
  const [form, setForm] = useState<FormData>({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    businessType: '',
    businessDesc: '',
    products: [],
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheckbox = (val: string) => {
    setForm((prev) => ({
      ...prev,
      products: prev.products.includes(val)
        ? prev.products.filter((p) => p !== val)
        : [...prev.products, val],
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`合作報名 - ${form.companyName}`);
    const body = encodeURIComponent(
      `公司名稱: ${form.companyName}\n聯繫人: ${form.contactPerson}\n電郵: ${form.email}\n電話/WhatsApp: ${form.phone}\n業務類型: ${form.businessType}\n業務描述: ${form.businessDesc}\n感興趣的產品: ${form.products.join(', ')}`
    );
    window.location.href = `mailto:hhess2071@gmail.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem 1rem',
    borderRadius: '0.75rem',
    border: '1px solid rgba(201,168,76,0.3)',
    backgroundColor: '#FDFAF5',
    color: '#2C2416',
    fontSize: '0.9rem',
    outline: 'none',
  };

  const labelStyle = {
    display: 'block',
    color: '#5C4A1E',
    fontWeight: 600,
    fontSize: '0.85rem',
    marginBottom: '0.5rem',
  };

  return (
    <div style={{ backgroundColor: '#F5F0E8', minHeight: '100vh' }}>
      <Header />

      {/* Page Hero */}
      <section
        style={{
          background: 'linear-gradient(135deg, #2C2416 0%, #5C4A1E 60%, #8B6914 100%)',
          padding: '5rem 0 4rem',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p style={{ color: '#C9A84C', fontWeight: 600, fontSize: '0.8rem', letterSpacing: '0.15em' }} className="mb-3">
            REGISTRATION · 報名中心
          </p>
          <h1 style={{ color: '#F5F0E8', fontWeight: 800 }} className="text-4xl sm:text-5xl mb-4">
            合作報名中心
          </h1>
          <p style={{ color: '#A09070', maxWidth: '600px', lineHeight: 1.8 }}>
            填寫以下表格，我們的團隊將盡快與您聯繫，探討合作機會。
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {submitted ? (
            <div
              className="rounded-2xl p-12 text-center"
              style={{ backgroundColor: '#FDFAF5', border: '1px solid rgba(201,168,76,0.3)' }}
            >
              <div className="text-5xl mb-4">✅</div>
              <h2 style={{ color: '#2C2416', fontWeight: 800 }} className="text-2xl mb-3">
                報名成功！
              </h2>
              <p style={{ color: '#5C4A1E', lineHeight: 1.8 }}>
                感謝您的報名，我們將盡快通過電郵與您聯繫。<br />
                如有緊急查詢，請直接聯繫：<br />
                <a href="mailto:hhess2071@gmail.com" style={{ color: '#C9A84C', fontWeight: 600 }}>hhess2071@gmail.com</a>
                {' '}或{' '}
                <a href="https://wa.me/85294995158" style={{ color: '#C9A84C', fontWeight: 600 }}>WhatsApp +852 9499 5158</a>
              </p>
            </div>
          ) : (
            <div
              className="rounded-2xl p-8 sm:p-10"
              style={{ backgroundColor: '#FDFAF5', boxShadow: '0 8px 40px rgba(44,36,22,0.1)', border: '1px solid rgba(201,168,76,0.2)' }}
            >
              <div className="mb-8">
                <h2 style={{ color: '#2C2416', fontWeight: 800 }} className="text-2xl mb-2">
                  合作夥伴報名表
                </h2>
                <p style={{ color: '#8B6914', fontSize: '0.85rem' }}>Partnership Registration Form</p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label style={labelStyle}>公司名稱 <span style={{ color: '#C9A84C' }}>*</span></label>
                    <input
                      type="text"
                      name="companyName"
                      value={form.companyName}
                      onChange={handleChange}
                      required
                      placeholder="Company Name"
                      style={inputStyle}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>聯繫人 <span style={{ color: '#C9A84C' }}>*</span></label>
                    <input
                      type="text"
                      name="contactPerson"
                      value={form.contactPerson}
                      onChange={handleChange}
                      required
                      placeholder="Contact Person"
                      style={inputStyle}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label style={labelStyle}>電郵 Email <span style={{ color: '#C9A84C' }}>*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="your@email.com"
                      style={inputStyle}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>電話 / WhatsApp <span style={{ color: '#C9A84C' }}>*</span></label>
                    <input
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      required
                      placeholder="+852 XXXX XXXX"
                      style={inputStyle}
                    />
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>業務類型 Business Type <span style={{ color: '#C9A84C' }}>*</span></label>
                  <select
                    name="businessType"
                    value={form.businessType}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  >
                    <option value="">請選擇 Please Select</option>
                    <option value="零售商 Retailer">零售商 Retailer</option>
                    <option value="批發商 Wholesaler">批發商 Wholesaler</option>
                    <option value="電商賣家 E-commerce Seller">電商賣家 E-commerce Seller</option>
                    <option value="其他 Other">其他 Other</option>
                  </select>
                </div>

                <div>
                  <label style={labelStyle}>業務描述 Business Description</label>
                  <textarea
                    name="businessDesc"
                    value={form.businessDesc}
                    onChange={handleChange}
                    rows={4}
                    placeholder="請簡述您的業務及合作需求..."
                    style={{ ...inputStyle, resize: 'vertical' }}
                  />
                </div>

                <div>
                  <label style={{ ...labelStyle, marginBottom: '0.75rem' }}>感興趣的產品類別 Products of Interest</label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {productOptions.map((opt) => (
                      <label
                        key={opt}
                        className="flex items-center gap-3 cursor-pointer p-3 rounded-xl transition-all"
                        style={{
                          backgroundColor: form.products.includes(opt) ? 'rgba(201,168,76,0.15)' : 'transparent',
                          border: `1px solid ${form.products.includes(opt) ? 'rgba(201,168,76,0.5)' : 'rgba(201,168,76,0.2)'}`,
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={form.products.includes(opt)}
                          onChange={() => handleCheckbox(opt)}
                          style={{ accentColor: '#C9A84C', width: '16px', height: '16px' }}
                        />
                        <span style={{ color: '#5C4A1E', fontSize: '0.82rem', fontWeight: 500 }}>{opt}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full py-4 rounded-xl font-700 text-base transition-all duration-300 hover:scale-[1.02]"
                  style={{ backgroundColor: '#C9A84C', color: '#2C2416', fontWeight: 700 }}
                >
                  提交報名 Submit Registration →
                </button>

                <p style={{ color: '#8B6914', fontSize: '0.78rem', textAlign: 'center' }}>
                  提交後將開啟您的郵件客戶端，或直接發送至 hhess2071@gmail.com
                </p>
              </form>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
